'use client';

import { useMemo } from 'react';
import { useRouter } from 'next/router';
import {
  useCreateProductFilters,
  useCreateRegionFilters,
} from '@/creditflowresearch/application/PageFilters/hooks/create';
import { Product, HycProduct, IgcProduct } from '@/creditflowresearch/domain/Product';
import type { IFilterSet } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';
import { transformToFilterSets } from './helpers/transformToFilterSets';

export const useAbsFilters = (): IFilterSet[] => {
  const router = useRouter();
  const { query } = router;
  const allProducts = useCreateProductFilters();
  const regions = useCreateRegionFilters();

  const products = useMemo(
    () => allProducts.filter(({ id }) =>
      !Product.isOfType(id, HycProduct.TYPE) && !Product.isOfType(id, IgcProduct.TYPE),
    ),
    [allProducts],
  );

  return transformToFilterSets([
    {
      key: 'regions',
      items: regions,
    },
    {
      key: 'products',
      items: products,
    },
  ], query);
};
